import { Subject } from 'rxjs';

const ndStateSubject = new Subject<string>();

/** Publishes the `ndstate` response header; a missing header is a no-op, so callers pass `headers.get('ndstate')` straight in. */
export function publishNdStateEvent(ndStateHeader: string | null | undefined): void {
    if (!ndStateHeader) {
        return;
    }
    ndStateSubject.next(ndStateHeader);
}

export const onNdStateChanged = ndStateSubject.asObservable();
